/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function initCollectionProductItemSwatch() {
    $(".CollectionInner__Products .ProductList > .Grid__Cell").each(function() {
        if ($(this).find("select.ProductSelect__variant").length && !$(this).find(".selector-wrapper").length) {
            var t = $(this).find("select.ProductSelect__variant"),
                e = t.attr("data-handle"),
                o = t.attr("id"),
                n = "/products/" + e + ".js";
            jQuery.getJSON(n, function(e) {
                new Shopify.OptionSelectors(o, {
                    product: e,
                    onVariantSelected: selectCallback,
                    enableHistoryState: !1
                }), $(e.options).each(function(e, o) {
                    t.parent(".select").find(".selector-wrapper").eq(e).find("label").text(o.name)
                }), initHTMLDropdown(t.parent(".select"))
            })
        }
    })
}
$(document).ready(function() {
    $(document).on("click", ".mm-custom-product-page-atc button", function(t) {
        t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:loading:start"));
        var e = $(this).parents("form").find('[name="id"]').val();
        $(this).hasClass("disabled") || (data = {
            id: e,
            quantity: 1
        }, jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            error: function(t, e, o) {
                var n = $.parseJSON(t.responseText);
                alert(n.description)
            },
            success: function(t) {
                console.log("sucess", t), GLOBAL_CART._onCollectionAdded(), document.dispatchEvent(new CustomEvent("theme:loading:end"))
            }
        }))
    })
  });


//# sourceMappingURL=/s/files/1/0601/1093/0098/t/56/assets/custom.js.map?v=137039234047158033361655996133